export default {
  computed: {
    hasDevAccess() {
      const store = this.$store
      const storeIndicatesDev = store && store.getters && store.getters['activeUser/isDev']
      return Boolean(process.env.MIX_DEV) || Boolean(storeIndicatesDev)
    },
    hasSettingsAccess() {
      const store = this.$store
      const getters = store && store.getters
      const storeIndicatesAdmin = getters && getters['activeUser/isAdmin']

      return this.hasDevAccess || Boolean(storeIndicatesAdmin)
    },
  },
}
